import { render, staticRenderFns } from "./carbon_oil.vue?vue&type=template&id=ad40e276&scoped=true"
import script from "./carbon_oil.vue?vue&type=script&lang=js"
export * from "./carbon_oil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad40e276",
  null
  
)

export default component.exports